export class SparkJobRetryPolicy {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "maxAttempts",
            "baseName": "maxAttempts",
            "type": "number",
            "format": ""
        },
        {
            "name": "cooldownInterval",
            "baseName": "cooldownInterval",
            "type": "number",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return SparkJobRetryPolicy.attributeTypeMap;
    }
    constructor() {
    }
}
